export default __webpack_public_path__ + "static/media/appleBlack.e5410a2a.svg";